import React, { useContext, useEffect, useState } from 'react'
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilClearAll, cilPencil, cilReload } from '@coreui/icons'
import SearchTable from 'src/components/searchTable'
import { activeArray, checkPermissions, raiseToast } from 'src/views/utils/helper'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown, faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { GlobalContext } from 'src/views/context/GlobalState'
import CreateCmsUser from './createCmsUser'
import { PERMISSIONS } from '../../../utils/permissions'
import useAxios from 'axios-hooks'
import { ROLE_LIST_API, USER_API } from '../../../utils/urls'
import { AppContext } from '../../../context/app'
import ActivateDeactivateUser from '../common/activateDeactivate'
import ResetPasswordModal from '../common/resetPasswordModal'

const CmsUserList = () => {
  const { userObj, userSessionObj } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)

  const [rolesList, setRolesList] = useState([])
  const [selectedUser, setSelectedUser] = useState({})

  const [usersList, setUsersList] = useState([])

  const [openModal, setOpenModal] = useState(false)
  const [userStatusModal, setUserStatusModal] = useState(false)
  const [resetPasswordModal, setResetPasswordModal] = useState(false)

  const createAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.USER_MANAGEMENT.CREATE,
  )
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.USER_MANAGEMENT.UPDATE,
  )

  const [{ data: roleList, loading: roleListLoading }, roleListCall] = useAxios(
    {
      url: ROLE_LIST_API,
      method: 'get',
    },
    { manual: true },
  )
  const [{ data: cmsUserList, loading: cmsUserListLoading }, cmsUserListCall] = useAxios(
    {
      url: `${USER_API}/cms-user`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createCmsUser, loading: createCmsUserLoading }, createCmsUserCall] = useAxios(
    {
      url: `${USER_API}/create`,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateCmsUser, loading: updateCmsUserLoading }, updateCmsUserCall] = useAxios(
    {
      url: `${USER_API}/update-role`,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    roleListCall()
    cmsUserListCall()
  }, [])

  useEffect(() => {
    setLoader(roleListLoading || cmsUserListLoading || createCmsUserLoading || updateCmsUserLoading)
  }, [roleListLoading, cmsUserListLoading, createCmsUserLoading, updateCmsUserLoading])

  useEffect(() => {
    if (roleList && roleList.success && cmsUserList && cmsUserList.success) {
      let tempUser = []
      let tempArr = roleList.data.filter(
        (ele) => ele.name !== 'subscriber' && ele.name !== 'Account Admin',
      )
      cmsUserList.data.forEach((ele) => {
        let roleString = ''

        let { roles } = ele

        roles.forEach((element, index) => {
          const roleObj = roleList.data.find((role) => role._id === element)
          if (roleObj) {
            roleString += `${roleObj.name}${index < roles.length - 1 ? ',' : ''} `
          }
        })
        if (userObj._id !== ele._id) {
          tempUser.push({ ...ele, roleName: roleString })
        }
      })
      setUsersList(tempUser)

      setRolesList(activeArray(tempArr))
    }
  }, [roleList, cmsUserList])

  useEffect(() => {
    if (createCmsUser && createCmsUser.success) {
      cmsUserListCall()
      raiseToast('success', 'User created successfully')
    }
  }, [createCmsUser])

  useEffect(() => {
    if (updateCmsUser && updateCmsUser.success) {
      cmsUserListCall()
      raiseToast('success', 'User updated successfully')
    }
  }, [updateCmsUser])

  // const handleStatus = async (info) => {
  // if (!updateAllowed)
  //   return dispatch(dispatchAlert('danger', `Error`, `Insufficient Permissions!!`, true))
  // let res = await dispatch(
  //   updateContact(
  //     {
  //       status: !info.status,
  //     },
  //     info._id,
  //   ),
  // )
  // if (res?.success) {
  //   dispatch({ type: 'REFRESH_DATA' })
  // } else {
  //   console.log('failed')
  // }
  // }

  const handleEdit = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedUser(info)
    setOpenModal(true)
  }
  const handleAdd = () => {
    if (!createAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedUser({})
    setOpenModal(!openModal)
  }

  const addCmsUser = (payload) => {
    createCmsUserCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editCmsUser = (payload) => {
    updateCmsUserCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const handleActivateDeactivate = (info) => {
    setSelectedUser(info)
    setUserStatusModal(true)
  }

  const handleResetPassword = (info) => {
    setSelectedUser(info)
    setResetPasswordModal(true)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 17,
    },
    {
      header: 'Email',
      dataCell: (info) => info.email_id,
      width: 22,
    },
    {
      header: 'Roles',
      dataCell: (info) => info.roleName,
      width: 33,
    },
    {
      header: 'Status',
      dataCell: (info) => (info.status ? 'Active' : 'In Active'),
      width: 10,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 14,
    },
    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CDropdown>
          <CDropdownToggle color="white" caret={false}>
            <FontAwesomeIcon icon={faEllipsisH} size="2x" />
          </CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem onClick={() => handleEdit(info)}>
              <CIcon icon={cilPencil} size="sm" />
              {'  Edit Roles'}
            </CDropdownItem>
            <CDropdownItem onClick={() => handleResetPassword(info)}>
              <CIcon icon={cilReload} size="sm" />
              {'  Reset Password'}
            </CDropdownItem>
            <CDropdownItem onClick={() => handleActivateDeactivate(info)}>
              <CIcon icon={cilClearAll} size="sm" />
              {!info.status ? ' Activate' : ' Deactivate'}
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      ),
      width: 9,
    },
  ]

  return (
    <>
      <h4>CMS Users</h4>
      <p>{`Manage your Users`}</p>
      <SearchTable
        type={`CMS User`}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ Add New User`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableConfig={tableConfig}
        tableContent={usersList}
        createPermission={createAllowed}
      />
      {openModal && (
        <CreateCmsUser
          openModal={openModal}
          onCancel={() => setOpenModal(false)}
          setOpenModal={setOpenModal}
          roleData={rolesList}
          userData={selectedUser}
          addCallback={addCmsUser}
          editCallback={editCmsUser}
        />
      )}
      {userStatusModal && (
        <ActivateDeactivateUser
          user={selectedUser}
          showModal={userStatusModal}
          handleClose={() => setUserStatusModal(false)}
          successCallback={cmsUserListCall}
        />
      )}
      {resetPasswordModal && (
        <ResetPasswordModal
          user={selectedUser}
          showModal={resetPasswordModal}
          handleClose={() => setResetPasswordModal(false)}
        />
      )}
    </>
  )
}

export default CmsUserList
